import { jsx } from "react/jsx-runtime";
import { Stack as MUIStack } from "@mui/material";
import { forwardRef } from "react";
const StackInner = (props, ref) => {
  return /* @__PURE__ */ jsx(
    MUIStack,
    {
      "data-testid": "biome-stack",
      ...props,
      ref
    }
  );
};
const Stack = forwardRef(StackInner);
export {
  Stack
};
